import { registerBlockType } from '@wordpress/blocks';

/**
 * Internal dependencies
 */
import json from './block.json';
import edit from './edit';
import save from './save';
import icons from './icons';

const { name, ...settings } = json;

registerBlockType(name, {
  ...settings,
  icon: icons.mobileContent,
  edit,
  save,
  __experimentalLabel: (attributes) => attributes.label || settings.title,
});
